import _ from 'lodash';
import { createZip, downloadURL } from '@gtintel/platform-utils';
export const downloadFile = source => {
  const fileName = source.split('/').pop();
  const el = document.createElement('a');
  el.setAttribute('href', source);
  el.setAttribute('download', fileName);
  document.body.appendChild(el);
  el.click();
  el.remove();
};
export const zipAndDownloadDocumentLibraryFolder = (fileName, downloadDocumentLibraryFolderResonse) => {
  const fileNames = Object.keys(downloadDocumentLibraryFolderResonse.data);
  const promises = Object.values(downloadDocumentLibraryFolderResonse.data).map(url => {
    return new Promise((resolve, reject) => {
      fetch(url.toString()).then(response => response.blob()).then(resolve).catch(reject);
    });
  });
  return Promise.all(promises).then(blobPromises => {
    const files = _.zip(fileNames, blobPromises);
    return createZip(files);
  }).then(content => {
    const blob = new Blob([content], {
      type: 'application/zip'
    });
    const url = URL.createObjectURL(blob);
    downloadURL(url, `${fileName || 'GTI-document-download'}.zip`);
    URL.revokeObjectURL(url);
  });
};